// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"df97c25d","247":"ad6fe1ca","453":"8820cf8d","627":"a4b1fe17","653":"583aef0d","834":"b82e5632","867":"af29df4e","923":"ca427d6f","938":"5ce861e3"}[chunkId] + ".chunk.js";
};